// Layout.jsx
import { Box, Flex, Container } from "@chakra-ui/react";
import TopNavbar from "./TopNavbar";

export default function Layout({ children }) {
  return (
    <Flex direction="column" minH="100vh" bg="gray.50">
      <Box as="header" role="banner" zIndex={10}>
        <TopNavbar />
      </Box>

      <Box as="main" role="main" aria-label="Hauptinhalt" py={6} flex="1">
        <Container maxW="7xl">{children}</Container>
      </Box>
    </Flex>
  );
}